import { render, staticRenderFns } from "./timeStatistics.vue?vue&type=template&id=5532f13a&"
import script from "./timeStatistics.vue?vue&type=script&lang=js&"
export * from "./timeStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports